import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';

import styles from './index.module.scss';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className={styles.notFoundPage}>
            <h1 className={styles.title}>
                404
            </h1>
            <div className={styles.description}>
                The Page you're looking for was not found.
            </div>
            <Button onClick={() => navigate(-1)} className={styles.btnBack} type="primary" size="large">Go Back</Button>
        </div>
    );
}

export default NotFound;